import { Component, OnInit } from '@angular/core';
import { ConvertDatetimePipe } from '../../../app/convert-datetime.pipe';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { ChangeUsersService } from '../../../app/services/change-users.service';
import * as moment from "moment-timezone";
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-boiler-room-device',
  templateUrl: './boiler-room-device.component.html',
  styleUrls: ['./boiler-room-device.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class BoilerRoomDeviceComponent implements OnInit {
  public assetsListUrl = BaseUrlConstantsService.ASSETS_LIST;
  public boiler_parameters_api = BaseUrlConstantsService.BOILER_PARAMETERS_API;
  public eBoilerRoomApi: any = BaseUrlConstantsService.eBoilerRoomApi;
  public boilerRotatingAssets: any = BaseUrlConstantsService.boilerRotatingAssets;
  public today: Date;
  public updated_at: any;
  public breadcrumbsArray: any = [
    {
      page_ref: "device-reports",
      page_title: "Boiler Room",
    },
    {
      page_ref: "#",
      page_title: "Device Room",
    }
  ];
  public company_name: string;
  public allDeviceSecondArray: any = [];
  public allDevices: any = [];
  public showEmptyError = '';
  pageName: string = "Boiler-device-room";
  public device_id:string;
  parameterType: any;
  public clientId: any;
  public deviceLoader: boolean =true;
  public tabName = 'tab-4';
  public tab1: any;
  public tab2: any;
  public tab3: any;
  public tab4: any;
  public subsystemId : any;
  public jsonDevices: any = [];
  public _timeOut: any;
  public forCount: number =0;
  public subsystem_name: string;
  constructor(
    public router: Router,
    public service: BackendApiService,
    private changeService: ChangeUsersService,
    public activeRoute: ActivatedRoute,
  ) {
    this.utcTime();
    if(localStorage.getItem('role') === 'ADMIN'){
      this.clientId = localStorage.getItem('admin_client_id');
      this.breadcrumbsArray = [
        {
          page_ref: "device-report-new",
          page_title: "Boiler Room",
        },
        {
          page_ref: "#",
          page_title: "Trend Analysis",
        },
      ];
    }
    else if(localStorage.getItem('role')=='CLIENT'){
      this.clientId = localStorage.getItem('user_id');
    }
    else{
      // this.clientId = localStorage.getItem('user_id');
      this.clientId = localStorage.getItem("associated_clientid") === "null" ? localStorage.getItem("user_id"): localStorage.getItem("associated_clientid");
    }
    this.subsystemId = localStorage.getItem('subsystem_id');
    activeRoute.queryParams.subscribe(params => {
      // console.log(params)
      this.tabName = params["tabName"],
        this.tab1 = params["tab1"],
        this.tab2 = params["tab2"],
        this.tab3 = params["tab3"],
        this.tab4 = params["tab4"],
      this.subsystemId = params['roomId'];
      this.subsystem_name = params['subsystem_name'];
    });
  }

  ngOnInit(): void {
    this.company_name = localStorage.getItem('company_name');
    this.subsystemId = localStorage.getItem('subsystem_id');
    this.subsystem_name = localStorage.getItem('subsystem_name');
    this.loadAllDevices();
    this.getLatestDateAndTime();
  }
  goToPageLink(name: string) {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        pageRef: "boiler-room",
        tabName: this.tabName,
        tab1: this.tab1,
        tab2 : this.tab2,
        tab3 : this.tab3,
        tab4 :this.tab4,
      },
    };
    let userRoll = localStorage.getItem("role");
    if(userRoll=='CLIENT' || userRoll=='USER')
      this.router.navigate(['/device-reports'],navigationExtras)
    else if(userRoll=='ADMIN'){
      this.router.navigate(['/device-report-new'],navigationExtras)
}
    // this.router.navigate([name], navigationExtras);
  }
  utcTime() {
    setInterval(() => {
      this.today = new ConvertDatetimePipe().convertDateTime(new Date());
    }, 1000);
  }
  moveOnDashboard(client_id, room_id, name){
    const navigationExtras = {
      skipLocationChange : true,
      queryParams: {
        clientId: client_id,
        subsystemId: room_id,
        subsystem_name: name,
        pageRef: "deviceRoom",
        tabName: this.tabName,
        tab1: this.tab1,
        tab2 : this.tab2,
        tab3 : this.tab3,
        tab4 :this.tab4,
      }
    }
    console.log(this.subsystem_name, "subsystem_name");
    this.router.navigate(['./eBoiler-dashboard'], navigationExtras);
  }

  ngOnDestroy() {
    if (this._timeOut !== undefined) {
      clearInterval(this._timeOut);
    }
  }

  loadAllDevices() {
    if (this._timeOut !== undefined) {
      clearTimeout(this._timeOut);
    }
    this.getallDevices();
    this.getParametersApi();
    let self = this;

    self._timeOut = setInterval(function () {
      self.getParametersApi();
      self.getallDevices();
    }, 60000);



  }


  getLatestDateAndTime(){
    this.service.getData(this.boiler_parameters_api +"latest-date/" + Math.floor(Math.random() * 90 + 10) + this.clientId + Math.floor(Math.random() * 9000 + 1000) + "/" + this.subsystemId)
    .then(res => {
      const response = JSON.parse(JSON.stringify(res)).data;
      console.log(response,'sdfsjisiddsi');
      if(response.status === "success"){
        if(response.body.length != 0){
          let testDateUtc = moment.utc(response.body[0].updated_at).toDate();
          this.updated_at = new ConvertDatetimePipe().convertDateTime(
            testDateUtc
          );
          console.log(this.updated_at,'updateday')
        }
      }
    })
  }


  async getallDevices() {
    if(this.forCount == 0)
    this.deviceLoader = true;
    // let userID = localStorage.getItem('admin_client_id') === 'null' ? localStorage.getItem('user_id') : localStorage.getItem('admin_client_id');
     await this.service
      .getDataWithQuery(
        this.eBoilerRoomApi + 'eBoiler' + '/room/' + Math.floor(Math.random() * 90 + 10) + this.subsystemId + Math.floor(Math.random() * 9000 + 1000)
      )
      .then((res:any) => {
        if (JSON.parse(JSON.stringify(res)).data.status === "success") {
          if (JSON.parse(JSON.stringify(res)).data.body.length !== 0) {

            this.jsonDevices = JSON.parse(res.data.body[0].device_position);
            // this.jsonDevices = this.jsonDevices.ROTATING_ASSETS;
          }
        }
      });
            this.service
            .getDataWithQuery(
            this.boilerRotatingAssets + Math.floor(Math.random() * 90 + 10) + this.clientId + Math.floor(Math.random() * 9000 + 1000) + "/" + this.subsystemId + "/eboiler"+"?assetFilter=" + 'ALL'
            +
            "&limit=" +
            100 +
            "&offset=" +
            0
          )
          .then((res) => {
            let response = JSON.parse(JSON.stringify(res)).data;
              if (response.status === "success") {
                if (response.body.length !== 0) {
                  this.forCount++;
                  this.allDevices = response.body; ;
                  // this.allDevices = deviceList.filter(device1 =>
                  //     this.jsonDevices.some(device2 => device2.id === device1.id)
                  // ).map(device1 => {
                  //     const device2 = this.jsonDevices.find(device2 => device2.id === device1.id);
                  //     return { ...device1, ...device2 };
                  // });
                  this.changeService.loader(false);
                  this.showEmptyError = "";
                  this.showEmptyError = "";
                  this.allDevices.forEach((e) => {
                    e.connected_sensors.sort((a, b) => b.lbl - a.lbl);
                    e.noOfSensors = e.connected_sensors.length;
                    e.connected_sensors.forEach((s, i) => {
                      let sensors = s.template_id.split("_");
                      if (sensors !== undefined && sensors.length > 2) {
                        //s.sno = i + 1;
                        if (s.id === e.id) {
                          s.master = 1;
                        } else {
                          s.master = 0;
                        }
                        s.lbl = sensors[0];
                        s.sno = sensors[0];

                        s.sensor = sensors[1];
                        s.parent = sensors[2];
                        if (sensors[2] == "secondry" || sensors[1] == "couple") {
                          e.parentS = true;
                        } else {
                          e.parentS = false;
                        }
                        e.new = true;
                        if (e.parentS) {
                          e.imgP = "./assets/motor_n.png";
                          e.asset_type_s = s.asset_type;
                        }

                        switch (s.asset_type) {
                          case "MOTOR":
                            if (e.parentS) {
                              e.imgS = "./assets/motor_n.png";
                            } else {
                              e.imgP = "./assets/motor_n.png";
                            }
                            break;
                          case "GEAR":
                            if (e.parentS) {
                              e.imgS = "./assets/gearbox.png";
                            } else {
                              e.imgP = "./assets/gearbox.png";
                            }
                            break;
                          case "PUMP":
                            if (e.parentS) {
                              e.imgS = "./assets/pump.png";
                            } else {
                              e.imgP = "./assets/pump.png";
                            }
                            break;
                          case "FAN_BLOWER":
                            if (e.parentS) {
                              e.imgS = "./assets/fan.png";
                            } else {
                              e.imgP = "./assets/fan.png";
                            }
                            break;
                          case "JOURNAL_BEARING":
                            if (e.parentS) {
                              e.imgS = "./assets/bearing2.png";
                            } else {
                              e.imgP = "./assets/bearing2.png";
                            }
                            break;
                          case "COMPRESSOR":
                            if (e.parentS) {
                              e.imgS = "./assets/compressor.png";
                            } else {
                              e.imgP = "./assets/compressor.png";
                            }
                            break;
                        }
                      }
                    });

                    // e.connected_sensors.sort((a, b) =>
                    //   a.parent > b.parent ? 1 : -1
                    // );
                    // e.connected_sensors.sort((a, b) => b.master - a.master);
                    // e.connected_sensors.sort((a, b) => b.device_sno - a.device_sno);
                  });
                  this.deviceLoader = false;
                  this.allDeviceSecondArray = this.allDevices;
                } else {
                  this.deviceLoader =false;
                  this.changeService.loader(false);
                  this.allDeviceSecondArray = [];
                  this.showEmptyError = "No Assets Available!";
                }
              } else {
                this.deviceLoader =false;
                this.changeService.loader(false);
                this.showEmptyError = "No Assets Available!";
                // this.service.showError("Something went wrong.");
              }
          });
      

  }
  async openDetailScreen(sensorData: any, allChild: any) {
    const assetChilds = allChild.connected_sensors.filter(x => { return x.device_sno != 1 });
    //this.pageName="SuperAdminpage"
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        pageRef:  this.pageName ,
        deviceId: sensorData.inventory_id,
        assetid: sensorData.id,
        label: sensorData.lbl,
        asset_type: sensorData.asset_type,
        sub_type: allChild.sub_type,
        device_serial_no: sensorData.device_sno,
        serial_no: sensorData.sno,
        assetStatus: sensorData.asset_status,
        sensorType: sensorData.sensor,
        no_of_children: assetChilds.length,
        asset_master_info: JSON.stringify(allChild),
        macaddress:sensorData.mac_address,
        route_path: "eBoiler-room-devices",
        tabName: this.tabName,
        tab1: this.tab1,
        tab2 :this.tab2,
        tab3 :this.tab3,
        tab4 :this.tab4,
      },
    }
    this.router.navigate(['detail-nxt'], navigationExtras);
  }
 getParametersApi(){
    this.service.getData(this.boiler_parameters_api + "parameters/latest/" + this.clientId +"/" + this.subsystemId)
    .then(res =>{
      let response = JSON.parse(JSON.stringify(res)).data;
      if(response.status === 'success'){
        if(response.body.sensor.length != 0){
          this.parameterType = response.body.sensor;
        }
      }
    });
  }
  getMoreParameters(){
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        pageRef: "Device-Room",
        subsystem_name: this.subsystem_name
      },
    };
    this.router.navigate(['/eboiler-parameters'],navigationExtras);
  }
}
